$('.multicolumn-reviews .multi-column').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768, // Target screen width (in pixels)
      settings: {
        slidesToShow: 1 // Show 1 slide on screens smaller than 768px
      }
    }
  ]
});
